import { type Browser, type OperatingSystem } from 'owa-user-agent';
import type { SupportedBrowserConfig } from '../schema/A2HSCampaignProvider.types';

export const getSupportedBrowserConfigs = (): SupportedBrowserConfig[] => [
    // Android - Chrome: [45, 68), >=76
    /**
     * Caveat:
     * Versions in [68,76) are not being supported because 'beforeInstallPromptEvent.preventDefault()'
     * doesn't let us suppress the browser default mini-infobar banner for A2HS. Associated links:
     *      1. https://developers.google.com/web/updates/2018/06/a2hs-updates
     *      2. https://developers.google.com/web/updates/2019/07/nic76
     */
    {
        browserName: 'Chrome',
        browserVersionRange: [[45], [68]],
        operatingSystems: ['Android'],
    },
    {
        browserName: 'Chrome',
        browserVersionRange: [76],
        operatingSystems: ['Android'],
    },

    // Android - Edge Anaheim: all versions
    {
        browserName: 'Edge Anaheim',
        operatingSystems: ['Android'],
    },

    // iOS - Safari: >= 13
    {
        browserName: 'Safari',
        browserVersionRange: [13],
        operatingSystems: ['iOS'],
    },
];
